import {TutorialState} from "@/Core/TutorialState";

export function render(html: string, state: TutorialState) {
    return renderText(renderPropertyValues(html, state), state);
}

export function renderText(html: string, state: TutorialState) {
    let regex = /{{([^}]+)}}/g;
    let match: RegExpExecArray|null;
    let matches = [];

    do {
        match = regex.exec(html);
        if (match) {
            matches.push({
                index: match.index,
                expr: match[1],
                length: match[0].length
            });
        }
    } while (match);

    if (matches.length == 0)
        return html;

    let result = [];
    let index = 0;

    for (let match of matches) {
        let before = html.substr(index, match.index - index);
        result.push(before);
        let variable = state.evaluate(match.expr);
        result.push(renderVariableAsText(match.expr, variable));
        index += before.length + match.length;
    }

    if (index + 1 < html.length) {
        result.push(html.substr(index));
    }

    return result.join('');
}

function renderPropertyValues(html: string, state: TutorialState) {
    let regex = /\:([a-zA-Z\-]+)\=\"([^"]+)\"/g;
    let match: RegExpExecArray|null;
    let matches = [];

    do {
        match = regex.exec(html);
        if (match) {
            matches.push({
                index: match.index,
                property: match[1],
                expr: match[2],
                length: match[0].length,
            });
        }
    } while (match);

    if (matches.length == 0)
        return html;

    let result = [];
    let index = 0;

    for (let match of matches) {
        let before = html.substr(index, match.index - index);
        result.push(before);
        result.push(match.property);
        result.push("=\"");
        let variable = state.evaluate(match.expr);
        result.push(variable);
        index += before.length + match.length;
        result.push("\"");
    }

    if (index + 1 < html.length) {
        result.push(html.substr(index));
    }

    return result.join('');
}

function renderVariableAsText(name: string, val: string) {
    if (val == null) {
        console.warn('Variable [' + name + '] is not defined');
        return "";
    }

    let str = val.toString();
    let result = "";
    for (let i = 0; i < str.length; i++) {
        if (str[i] === '<')
            result += '&lt;';
        else if (str[i] === '>')
            result += '&gt;';
        else if (str[i] === '&')
            result += '&amp;';
        else if (str[i] === '\'')
            result += '&apos;';
        else if (str[i] === '\"')
            result += '&quot;';
    }

    return str;
}